var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6424A9F7B0Aaffe39279A51DInnovationIconDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 56,
    viewBox: "0 0 46 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_17859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.586,
    cy: 13.4508,
    rx: 13.5758,
    ry: 13.5758,
    fill: "#FF7020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5852 40.7761H11.3124V40.3491L10.9395 40.141L10.5852 40.7761ZM10.5852 48.3645H9.85789V49.0918H10.5852V48.3645ZM27.4399 48.3645V49.0918H28.1672V48.3645H27.4399ZM27.4399 40.7737L27.0853 40.1387L26.7126 40.3468V40.7737H27.4399ZM2.4221 25.645C2.4221 16.4836 9.84892 9.05686 19.0103 9.05686V7.60232C9.0456 7.60232 0.967551 15.6803 0.967551 25.645H2.4221ZM10.9395 40.141C5.85681 37.3049 2.4221 31.8756 2.4221 25.645H0.967551C0.967551 32.4239 4.7063 38.3286 10.2308 41.4112L10.9395 40.141ZM11.3124 48.3645V40.7761H9.85789V48.3645H11.3124ZM27.4399 47.6372H10.5852V49.0918H27.4399V47.6372ZM26.7126 40.7737V48.3645H28.1672V40.7737H26.7126ZM35.5985 25.645C35.5985 31.8738 32.1657 37.3019 27.0853 40.1387L27.7945 41.4087C33.3164 38.3253 37.0531 32.422 37.0531 25.645H35.5985ZM19.0103 9.05686C28.1717 9.05686 35.5985 16.4836 35.5985 25.645H37.0531C37.0531 15.6803 28.975 7.60232 19.0103 7.60232V9.05686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90186 51.6196L28.1174 51.6196",
    stroke: "white",
    strokeWidth: 1.45455,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3835 54.875L25.6308 54.875",
    stroke: "white",
    strokeWidth: 1.45455,
    strokeLinejoin: "bevel"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_17859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6424A9F7B0Aaffe39279A51DInnovationIconDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6424a9f7b0aaffe39279a51d_innovation-icon-darkstudio-x-webflow-template.237adcee8a3541c7151ac59942f73943.svg";
export { ForwardRef as ReactComponent };